<template>
  <v-expansion-panels 
    :value="panels" 
    @input="$emit('update:panels', $event)"
    flat 
    class="mt-5 white"
  >
    <v-expansion-panel>
      <v-expansion-panel-header hide-actions>           
        <h5 class="black--text">
          <i class="aberto v-icon notranslate mdi mdi-chevron-down theme--light primary--text"></i>
          <i class="fechado v-icon notranslate mdi mdi-chevron-right theme--light primary--text"></i>
          Tarefas percorridas
        </h5>
      </v-expansion-panel-header>
      
      <v-expansion-panel-content class="pl-3 pr-3">
        <div v-if="tarefasPercorridas.length === 0" class="text-center pa-5">
          <v-icon size="64" color="grey lighten-1">mdi-file-tree-outline</v-icon>
          <p class="grey--text mt-3">Nenhuma tarefa encontrada</p>
        </div>
        <FlowTimelineComponent
          v-else
          :items="tarefasPercorridasFormatadas"
          :pco_tarefa_atual="pcoTarefaId"
          :circuito="circuito"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FlowTimelineComponent from '../components/nova_ficha/FlowTimelineComponent.vue';
import EventBus from '@/common/helpers/EventBus';


export default {
  name: 'TarefasPercorridasSection',
  
  components: {
    FlowTimelineComponent
  },
  
  props: {
    circuito: {
      type: Object,
      required: true
    },
    pcoTarefaId: {
      type: [String, Number],
      required: true
    },
    panels: {
      type: Number,
      default: 0
    },
    tarefa: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tarefasPercorridas: []
    }
  },

  async created() {
    await this.carregarTarefasPercorridas();
    
    EventBus.$on("tratativaAtualizada", this.handleTratativaAtualizada);
  },

  beforeDestroy() {
    EventBus.$off("tratativaAtualizada", this.handleTratativaAtualizada);
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'historicoTicket'
    ]),

    ticketRecuperacaoId() {
      return this.tarefa?.pco_workflow_id ?? null;
    },

    ticketData() {
      return this.historicoTicket || null;
    },

    tarefasPercorridasFormatadas() {
      
      if (!this.tarefasPercorridas.length) return { data: [] };

      const tarefasFormatadas = this.tarefasPercorridas.map((tarefa) => {
        const statusAtual = tarefa.status?.ctrl_status?.status || 'sem status';

        const agingDias = tarefa.aging_dias || 0;
        const agingMinutos = tarefa.aging_minutos || 0;
        const agingDiasFormatado = `${agingDias}d`;
        const horas = Math.floor(agingMinutos / 60);
        const minutos = agingMinutos % 60;
        const agingMinutosFormatado = `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`;
        
        return {
          id: tarefa.id,
          pco_tarefa: {
            id: tarefa.id,
            ctrl_tarefa: tarefa.ctrl_tarefa,
            ctrl_tipo_tarefa_id: tarefa.ctrl_tipo_tarefa_id,
            user_tratamento: tarefa.usuario_tratamento,
            pco_tratamento_fechamento: tarefa.tratamentos?.find(t => t.finalized_at) || null,
            user_cadastro: tarefa.usuario_tratamento,
            aging_minutos: agingMinutos,
            pco_tarefa_interrupcao_id: tarefa.pco_tarefa_interrupcao_id || null
          },
          created_at: tarefa.created_at,
          finalized_at: tarefa.finalized_at,
          status: statusAtual,
          aging_dias: agingDias,
          aging_dias_formatado: agingDiasFormatado,
          aging_minutos_formatado: agingMinutosFormatado
        };
      });

      return {
        data: tarefasFormatadas
      };
    }
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'buscarHistoricoTicket'
    ]),

    async handleTratativaAtualizada() {
      await this.carregarTarefasPercorridas();
    },

    async carregarTarefasPercorridas() {
      
      if (!this.ticketRecuperacaoId) {
        return;
      }

      try {
        await this.buscarHistoricoTicket(this.ticketRecuperacaoId);
                
        if (this.ticketData?.tarefas) {
          this.tarefasPercorridas = this.ticketData.tarefas.sort((a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA; // Ordem decrescente (mais recente primeiro)
          });
        } 
      } catch (error) {
        console.error('Erro ao buscar tarefas percorridas:', error);
      }
    }
  },

  watch: {
    ticketRecuperacaoId: {
      async handler(newVal) {
        if (newVal) {
          await this.carregarTarefasPercorridas();
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.theme--light.v-expansion-panels .v-expansion-panel {
  background: transparent !important;
}

.v-expansion-panel-header, .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-expansion-panel:before {
  box-shadow: none !important;
}

.v-expansion-panel-header .aberto {
  transition: display 5s linear;
  display: none !important;
}

.v-expansion-panel-header .fechado {
  display: inline !important;
}

.v-expansion-panel-header--active .aberto {
  transition: display 5s linear;
  display: inline !important;
}

.v-expansion-panel-header--active .fechado {
  display: none !important;
}

.v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
  left: calc(10.32% - 1px);
  right: auto;
}
</style>
